import React from 'react';
import classnames from 'classnames';
import MaskedInput from 'react-text-mask';

const FormControl = ({
  name,
  label,
  required = false,
  options,
  labelFn = (o) => o.label,
  valueFn = (o) => o.value,
  value,
  setValue,
  multi = false,
  type = 'text',
  autoFocus,
  disabled,
  children,
}) => {
  const fullLabel = label + (type === 'date' ? ' (mm/dd/yyyy)' : '') + (required ? '*' : '');
  let input;
  const inputProps = {
    id: name,
    name,
    className: 'form-control',
    required,
    value: value || '',
    onChange: (evt) => setValue(evt.target.value),
    placeholder: fullLabel,
    disabled: disabled || !setValue,
    autoFocus,
  };

  if (children) {
    input = children;
  } else if (options) {
    input = (
      <select {...inputProps} className={classnames('form-control', !value && 'placeholder')}>
        <option value="">{fullLabel}</option>
        {options.map((option) => (
          <option key={valueFn(option)} value={valueFn(option)}>
            {labelFn(option)}
          </option>
        ))}
      </select>
    );
  } else if (multi) {
    input = <textarea {...inputProps} />;
  } else if (type === 'tel') {
    input = (
      <MaskedInput
        type="text"
        guide={false}
        inputMode="numeric"
        mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
        {...inputProps}
        pattern="\([0-9]{3}\) [0-9]{3}-[0-9]{4}"
        title="Phone number should contain 10 digits."
      />
    );
  } else if (type === 'date') {
    input = (
      <MaskedInput
        type="text"
        guide={false}
        inputMode="numeric"
        placeholderChar={'\u2000'}
        mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
        {...inputProps}
      />
    );
  } else if (type === 'zip') {
    input = (
      <MaskedInput
        type="text"
        guide={false}
        inputMode="numeric"
        placeholderChar={'\u2000'}
        mask={[/\d/, /\d/, /\d/, /\d/, /\d/]}
        {...inputProps}
      />
    );
  } else {
    input = <input type={type} {...inputProps} />;
  }

  return (
    <div className="form-group">
      <label htmlFor={name} className="control-label sr-only">
        {label}
      </label>
      {input}
      {/* Disabled form fields don't submit values, so also include a hidden field */}
      {inputProps.disabled && (
        <input type="hidden" name={inputProps.name} value={inputProps.value} />
      )}
    </div>
  );
};

export default FormControl;
